
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 13.5a1 1 0 110 2 1 1 0 010-2zm-3.233-1.05a1 1 0 11-1.175 1.618 1 1 0 011.175-1.618zm7.863.22a1 1 0 11-1.618 1.176 1 1 0 011.618-1.175zM8 4a2.813 2.813 0 012.567 3.967l-.16.32-2.05 3.516a.396.396 0 01-.683.003L5.567 8.239l-.055-.111A2.813 2.813 0 018 4zM2.77 9.7a1 1 0 11-1.903.618A1 1 0 012.77 9.7zm11.72-.642a1 1 0 11-.617 1.902 1 1 0 01.618-1.902zM8 6.104a.851.851 0 100 1.702.851.851 0 000-1.702zM2.127 5.04a1 1 0 11-.618 1.902 1 1 0 01.618-1.902zm13.006.642a1 1 0 11-1.902.618 1 1 0 011.902-.618zM4.988 2.154A1 1 0 113.37 3.329a1 1 0 011.618-1.175zm7.42-.222a1 1 0 11-1.175 1.618 1 1 0 011.175-1.618zM8 .5a1 1 0 110 2 1 1 0 010-2z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    